import React, { useState } from "react";
import { useNotifications } from "../context/NotificationContext";
import { useNavigate } from "react-router-dom";

const BellIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    className={className}
  >
    <path d="M14 10V6a4 4 0 10-8 0v4a2 2 0 01-.586 1.414L4 13h12l-1.414-1.586A2 2 0 0114 10z" />
    <path d="M8 15h.01M9 19a1 1 0 11-2 0" />
  </svg>
);

export default function NotificationBell() {
  const [open, setOpen] = useState(false);
  const { notifications, unreadCount, clearNotifications, markAllAsRead } =
    useNotifications();
  const navigate = useNavigate();

  const toggle = () => {
    setOpen((v) => !v);
    if (unreadCount > 0) markAllAsRead();
  };

  const goToNotification = (n) => {

    if (n.type === "message" && n.conversationId) {
      navigate(`/chat/${n.conversationId}`);
    }

    if (n.type === "new-announcement" && n.roomId) {
      navigate(`/annonce/${n.roomId}`);
    }

    setOpen(false);
  };

  return (
    <div className="relative">
      {/* Bouton cloche */}
      <button onClick={toggle} className="relative p-2">
        <BellIcon className="w-7 h-7 text-gray-700 hover:text-blue-600" />

        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs rounded-full px-1.5">
            {unreadCount}
          </span>
        )}
      </button>

      {/* Dropdown */}
      {open && (
        <div className="absolute right-0 mt-3 w-80 bg-white shadow-xl rounded-xl border border-gray-200 z-[10000]">
          <div className="flex justify-between items-center px-4 py-2 border-b">
            <h3 className="font-semibold">Notifications</h3>

            <button
              className="text-blue-600 text-sm"
              onClick={clearNotifications}
            >
              Effacer tout
            </button>
          </div>

          <div className="max-h-80 overflow-y-auto">
            {notifications.length === 0 ? (
              <p className="p-4 text-gray-500 text-sm">Aucune notification</p>
            ) : (
              notifications.map((n, index) => (
                <div
                  key={index}
                  onClick={() => goToNotification(n)}
                  className="p-3 cursor-pointer hover:bg-gray-100 border-b"
                >
                  <div className="font-medium text-gray-800 capitalize">
                    {n.type === "new-announcement" ? "Nouvelle annonce" : "Message"}
                  </div>

                  <div className="text-sm text-gray-600">{n.contentPreview}</div>

                  <div className="text-xs text-gray-400 mt-1">
                    {new Date(n.timestamp).toLocaleString("fr-FR")}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}
